module.exports = __webpack_public_path__ + "img/only-books.1084bc7b.svg";